import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router";

import { Card, TabMenu } from "@digital-services/ui";
import { ITabMenuTab } from "@digital-services/ui/types";

import { useTabIndex } from "@hooks/useTabIndex";

const OrganizationTabMenu: FC = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  const tabs: ITabMenuTab[] = [
    {
      id: "organization",
      label: t("tab-labels.organization"),
      content: (
        <Card className="" data-testid="organization-tab-card">
          <Outlet />
        </Card>
      )
    },
    {
      id: "applications",
      label: t("tab-labels.applications"),
      content: (
        <Card className="" data-testid="applications-tab-card">
          <Outlet />
        </Card>
      )
    },
    {
      id: "admins",
      label: t("tab-labels.admins"),
      content: (
        <Card className="" data-testid="admins-tab-card">
          <Outlet />
        </Card>
      )
    },
    {
      id: "parent-organization",
      label: t("tab-labels.parent-organization"),
      content: (
        <Card className="" data-testid="parent-organization-tab-card">
          <Outlet />
        </Card>
      )
    },
    {
      id: "resources",
      label: t("tab-labels.resources"),
      content: (
        <Card className="" data-testid="resources-tab-card">
          <Outlet />
        </Card>
      )
    }
  ];

  const { currentTabIndex } = useTabIndex(tabs);
  const navigate = useNavigate();

  const handleChangeTab = (tabIndex: number) => {
    if (tabIndex === 0) {
      return navigate("");
    }

    navigate(tabs[tabIndex].id.toLowerCase());
  };

  return (
    <TabMenu value={currentTabIndex} onChange={handleChangeTab} tabs={tabs} />
  );
};

export default OrganizationTabMenu;
